import { lazy } from "react";

const TextField = require('components/util/schema_form/fields/TextField').default;

const NumberField = require('components/util/schema_form/fields/NumberField').default;

const HourField = lazy(() => import("components/util/schema_form/fields/HourField"));

const SelectField = lazy(() => import("components/util/schema_form/fields/SelectField"));

const DynamicSelectField = require('components/util/schema_form/fields/DynamicSelectField').default;

const TextAreaField = require('components/util/schema_form/fields/TextAreaField').default;

const LocationField = lazy(() => import("components/util/schema_form/fields/LocationField"));

const ConfirmField = require('components/util/schema_form/fields/ConfirmField').default;

const PhoneField = lazy(() => import("components/util/schema_form/fields/PhoneField"));

const CheckboxField = require('components/util/schema_form/fields/CheckboxField').default;

const FileField = require('components/util/schema_form/fields/FileField').default;

const CodeField = lazy(() => import("components/util/schema_form/fields/CodeField"));

const LabelField = require('components/util/schema_form/fields/LabelField').default;

const AssetField = lazy(() => import("components/util/schema_form/fields/AssetField"));

const SchemaBuilderField = lazy(() => import("components/util/schema_form/fields/SchemaBuilderField"));

const MatchField = lazy(() => import("components/util/schema_form/fields/MatchField"));

const VariableField = lazy(() => import("components/util/schema_form/fields/variable/VariableField"));

const AccountPicker = lazy(() => import("components/util/schema_form/fields/account_picker/AccountPicker"));

const ButtonField = require('components/util/schema_form/fields/ButtonField').default;

const RichText = lazy(() => import("components/util/schema_form/fields/rich_text/RichText"));

const FilterField = lazy(() => import("components/util/schema_form/fields/FilterField"));

const ColorPickerField = require('components/util/schema_form/fields/ColorPicker').default;

const DataViewerField = lazy(() => import("components/util/schema_form/fields/DataViewer"));

const DashboardBuilderField = lazy(() => import("components/util/schema_form/fields/dashboard/DashboardBuilder"));

const TableField = lazy(() => import("components/util/schema_form/fields/TableField"));

const SelectorField = lazy(() => import("components/util/schema_form/fields/SelectorField"));

const RecursiveSelectField = require('components/util/schema_form/fields/RecursiveSelectField').default;

const SmartTextField = require('components/util/schema_form/fields/smart_text/SmartText').default;

const ExcelField = lazy(() => import("components/util/schema_form/fields/ExcelField"));

const CollectionBuilderField = lazy(() => import("components/util/schema_form/fields/CollectionBuilderField"));

export {
    TextField, SelectField, NumberField, HourField, LocationField,
    DynamicSelectField, TextAreaField, CheckboxField, FileField, AssetField,
    CodeField, LabelField, SchemaBuilderField, MatchField, VariableField,
    AccountPicker, ButtonField, RichText, FilterField, ColorPickerField,
    DataViewerField, DashboardBuilderField, TableField, SelectorField,
    RecursiveSelectField, ConfirmField, PhoneField,
    SmartTextField, ExcelField, CollectionBuilderField
};

